export default function addTagFilters(self, fields) {
  // We don't have a glossary of terms
  if (!self.glossary) {
    return;
  }

  const tagDefinitions = Object.entries(self.glossary).reduce(function (
    memo,
    [key, definition],
  ) {
    if (definition.definesType === "tag") {
      if (definition.key != self.definition.key) {
        memo.push(definition);
      }
    }

    return memo;
  }, []);

  if (!tagDefinitions.length) {
    return;
  }

  tagDefinitions.forEach(function (def) {
    const title = def.plural;
    fields.push({
      title,
      filterTitle: `Tags › ${title}`,
      minimum: 0,
      maximum: 0,
      key: `meta.tags|${def.key}`,
      type: "reference",
      referenceType: def.key,
    });

    // ?${def.key}
  });
}
